<template>
  <div class="popularAccountsBox" v-if="itemsRendered">
    <!-- For Non-Advertiser --> 
     
    <h2  class="mt-10">{{title}}</h2>
    <div class="anchor-tag four-a-color">
      <how-da-gets-paid></how-da-gets-paid> <span style="padding-left: 4px; padding-right: 4px; color: #aaa;">  | </span> <ad-disclosure-tooltip></ad-disclosure-tooltip>
    </div>   
    <table class="table pa-table">
      <tbody>
        <tr class="popular-account-head">
          <th><apy-label></apy-label></th>
          <th class="hidden-xs">ACCOUNT TYPE</th>
          <th>HOW THEY COMPARE</th>
        </tr>       
        <popular-account
          v-for="ad in popularAccountsWithAd"
          v-bind:key="ad.id"
          v-bind:popularAccount="ad"
        ></popular-account>
      </tbody>
    </table>
    <div class="view-all-link">
      <a href="#rates">View all {{bank.Name}} rates &raquo;</a>
    </div>
  </div>
   <div class="popularAccountsBox" v-else>    
   <div class="row">
            <div class="col-12 col-sm colWithoutLeftPadding">
                <div class="firstLine da-skeleton-loader"></div>
                <div class="secondLine da-skeleton-loader"></div>
                <div class="firstLine da-skeleton-loader"></div>
                <div class="secondLine da-skeleton-loader"></div>
                <div class="firstLine da-skeleton-loader"></div>
                <div class="secondLine da-skeleton-loader"></div>
                <div class="secondLine da-skeleton-loader"></div>
            </div>            
        </div>
  </div>  
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import popularAccount from "./popularAccount.vue";
import apiClient from "../../../services/apiClient";
import analytics from "../../../services/analytics";
import Enumerable from "linq";
import apyLabel from "../../../components/apyLabel.vue";
import howDaGetsPaid from '../../../components/how-da-get-paid.vue';
import adDisclosureTooltip from '../../../components/ad-disclosure-tooltip.vue';

export default defineComponent({
  name: "popularAccountsForNonAdvertiser",
  components: {
    popularAccount: popularAccount,
    apyLabel: apyLabel,
    howDaGetsPaid,
    adDisclosureTooltip
  },
  props: {
    popularAccounts: Array as any,
    bank: Object as any
  },
  data: function() {
    return {
      popularAccountsWithAd: [],
      itemsRendered: false,      
    };
  },
  computed: {
    title: function() : string {
      return (
        "Popular Accounts at this " +
        ((this.bank as any).InstitutionType == "CU" ? "Credit Union" : "Bank")
      );
    },
    filteredPopularAccounts: function() : any {
      var pa: any = this.popularAccounts;
      var output = [];

      for (var i = 0; i < 3 && i < pa.length; i++) {
        if (pa[i].Account != null) {
          output.push(pa[i]);
        }
      }
      return output;
    }
  },
  mounted() {
    const zoneKeyProducts = this.getZoneKeyNameForProduct();
    const zoneNames = Enumerable.from(zoneKeyProducts)
      .select(x => {
        return (x as any).adZoneName;
      })
      .toArray();

    apiClient.getAdZones(zoneNames).then(adZones => {
      this.itemsRendered = true;
      const associateAdWithAdZone = this.associateAdWithZone(
        zoneKeyProducts,
        adZones
      );

      this.popularAccountsWithAd = this.bindAdToPopularAccounts(
        associateAdWithAdZone
      );

      const ads = Enumerable.from(this.popularAccountsWithAd)
        .select(x => (x as any).Ad)
        .where(ad => ad != null)
        .toArray();

      if (!ads.length) {
        return;
      }
      analytics.trackAdImpressions("", ads);
    });
  },
  methods: {
    bindAdToPopularAccounts(adZoneWithAd: any): any {
      const popularAccountsWithAd = Enumerable.from(this.popularAccounts)
        .join(
          adZoneWithAd,
          "popularAccount => popularAccount.Product.Id" as any,
          "adWithProd => adWithProd.prodId" as any,
          "(pa,adWithProd)=> {pa:pa,Ad:adWithProd.ad}" as any
        )
        .select(x => {
          const pa = (x as any).pa;
          pa.Ad = (x as any).Ad;

          return pa;
        })
        .toArray();
      return popularAccountsWithAd;
    },
    // Match account by product id to ad
    associateAdWithZone(zones: any, adZones: any) {
      const topFirstAdWithAdZone: any = adZones.map((zone: any) => {
        const adWithZone = {
          adZoneName: zone.keyName,
          topFirstAd: zone.placements[0]
        };
        if(adWithZone.topFirstAd) adWithZone.topFirstAd.keyName = adWithZone.adZoneName;
        return adWithZone;
      });

      const selectedAdZoneProducts = Enumerable.from(
        this.filteredPopularAccounts
      )
        .join(
          zones,
          "outer => outer.Product.Id" as any,
          "inner => inner.prodId" as any,
          "(o,i)=>i" as any
        )
        .toArray();

      const selectedAds = Enumerable.from(topFirstAdWithAdZone)
        .join(
          selectedAdZoneProducts,
          "adZone=>adZone.adZoneName" as any,
          "product => product.adZoneName" as any,
          "(adZone,prod)=>{ad: adZone.topFirstAd, prodId:prod.prodId}" as any
        )
        .toArray();

      // Must not match more than 1 of same product id
      const adWithAdZone = Enumerable.from(selectedAdZoneProducts)
        .select((adZone: any) => {
          const filteredAd: any = Enumerable.from(selectedAds)
            .where(x => (x as any).prodId === adZone.prodId)
            .firstOrDefault();
          const selectedAd = filteredAd ? filteredAd.ad : null;

          return {
            prodId: adZone.prodId,
            ad: selectedAd
          };
        })
        .toArray();

      return adWithAdZone;
    },
    getZoneKeyNameForProduct() {
      const productIds = Enumerable.from(this.popularAccounts)
        .select(x => (x as any).Product.Id)
        .distinct()
        .toArray();

      const zoneKeyProducts = productIds.map(prodId => {
        const zoneKeyProd = this.getSuffixForProduct(prodId);
        const adZoneName = "da-bp-ac-" + zoneKeyProd;
        return {
          prodId,
          adZoneName: adZoneName
        };
      });

      return zoneKeyProducts;
    },
    getSuffixForProduct(productId: Number) {
      let result = "";
      switch (productId) {
        case 1:
          result = "cd3m";
          break;
        case 2:
          result = "cd6m";
          break;
        case 3:
          result = "cd1";
          break;
        case 4:
          result = "cd18m";
          break;
        case 5:
          result = "cd2";
          break;
        case 6:
          result = "cd3";
          break;
        case 7:
          result = "cd4";
          break;
        case 8:
          result = "cd5";
          break;
        case 9:
          result = "sav";
          break;
        case 13:
          result = "chk";
          break;
        case 26:
          result = "rwd";
          break;
        case 16:
          result = "ira1";
          break;
        case 18:
          result = "ira2";
          break;
        case 21:
          result = "ira5";
          break;
        case 22:
          result = "mma";
          break;
      }
      return result;
    }
  }
});
</script>
<style lang="scss" scoped>
.popularAccountsBox {
  margin-bottom: 15px;
  .pa-table {
    font-family: "Titillium Web";
    margin-bottom: 15px;
    tbody {
      .popular-account-head th {
        &:first-child {
          text-align: center;
        }

        border-top: none;
        color: #666;
        font-style: normal;
        background-color: transparent;
        font-weight: 600;
        border-bottom: 1px dotted #999;

        &:last-child {
          background-color: #dddddd;
        }
      }
    }
  }
  .view-all-link{
    margin-bottom:20px;
  }
}
@keyframes loading {
            100% {
                transform: translateX(100%);
            }
        }

        .da-skeleton-loader {
            background: rgba(221, 221, 221, 0.4);
            overflow: hidden;
            position: relative;
        }

            .da-skeleton-loader::after {
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
                animation: loading 1.5s infinite;
                content: "";
                height: 100%;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                transform: translateX(-100%);
                z-index: 1;
            }

         .firstLine {
            min-width: 140px;
            min-height: 25px;
            margin-bottom: 8px;
            margin-top:10px;
            border-radius: 3px;
        }
          .secondLine {
            min-width: 140px;
            min-height: 15px;
            margin-bottom: 8px;
            margin-top:10px;
            border-radius: 3px;
        }
  .anchor-tag{
      color: #4699bb;
      margin-bottom: 15px;
}
.mt-10{
  margin-top: 10px;
}
.four-a-color {
          color: #4a4a4a !important;
        }
</style>
